import { createActions } from 'redux-actions';

export const {
  getPositionsRepresentatives,
  getPositionsRepresentativesSuccess,
  getPositionsRepresentativesError,
  getCustomersStatuses,
  getCustomersStatusesSuccess,
  getCustomersStatusesError,
  getResponsibles,
  getResponsiblesSuccess,
  getResponsiblesError,
} = createActions(
  'GET_POSITIONS_REPRESENTATIVES',
  'GET_POSITIONS_REPRESENTATIVES_SUCCESS',
  'GET_POSITIONS_REPRESENTATIVES_ERROR',
  'GET_CUSTOMERS_STATUSES',
  'GET_CUSTOMERS_STATUSES_SUCCESS',
  'GGET_CUSTOMERS_STATUSES_ERROR',
  'GET_RESPONSIBLES',
  'GET_RESPONSIBLES_SUCCESS',
  'GET_RESPONSIBLES_ERROR'
);
